import { User } from '@/services/types/user-types';

const USER_1_PASSWORD = import.meta.env.VITE_APP_USER_1_PASSWORD;
// const USER_1_NAME = import.meta.env.VITE_APP_USER_1_NAME;

const getPasswordBasedOnUser = (
  username: string,
  password: string,
): boolean => {
  // switch (username) {
  if (password === USER_1_PASSWORD) {
    return true;
  }
  return false;
  // case USER_1_NAME:
  //   if (password === USER_1_PASSWORD) return true;
  //   break;
  // default:
  //   return false;
};

const getCsrfToken = () => {
  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith('csrftoken='))
    ?.split('=')[1];
  return cookieValue;
};

export const getUserDisplayName = (user: User) => {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  return user.email;
};

export { getCsrfToken, getPasswordBasedOnUser };
